import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './WhatsNext.style';

export const WHATS_NEXT_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  UNKNOWN: 'unknown',
};

const STATUS_MESSAGE_IDS = {
  [WHATS_NEXT_STATUS.SUCCESS]: 'dashboard.paymentReturn.whatsNext.noUnpaid',
  [WHATS_NEXT_STATUS.FAILURE]: 'dashboard.paymentReturn.whatsNext.hasUnpaid',
  [WHATS_NEXT_STATUS.UNKNOWN]: 'dashboard.paymentReturn.whatsNext.couldNotCheck',
};

export default function WhatsNext({ status, unpaidCount }) {
  const messageId = STATUS_MESSAGE_IDS[status];
  const messageValues = status === WHATS_NEXT_STATUS.FAILURE ? { unpaidCount } : undefined;

  return (
    <Stack gap={2}>
      <Text size="lg" weight="bold">
        <FormattedMessage id="dashboard.paymentReturn.whatsNext.title" />
      </Text>
      <Stack gap={1.5}>
        <Stack direction="row" gap={1.5} alignItems="center">
          <Styled.StatusCircleIcon />
          <Text size="sm" color="secondary">
            <FormattedMessage id={messageId} values={messageValues} />
          </Text>
        </Stack>
        <Stack direction="row" gap={1.5} alignItems="center">
          <Styled.StatusCircleIcon />
          <Text size="sm" color="secondary">
            <FormattedMessage id="dashboard.paymentReturn.whatsNext.servicesActive" />
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}

WhatsNext.propTypes = {
  status: PropTypes.oneOf(Object.values(WHATS_NEXT_STATUS)).isRequired,
  unpaidCount: PropTypes.number,
};
